
import { Component, Vue, Watch } from 'vue-property-decorator';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import {
  BlockStore,
  FloweringStore,
  FarmStore,
  CommonStore
} from '@/store/modules';
import { FloweringBatchUpload, UploadProgress } from '@/store/models/flowering';

@Component({
  components: {
    QvSelect,
    ValidationObserver,
    ValidationProvider
  }
})
export default class BatchUploadTreeForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  data: FloweringBatchUpload = {} as FloweringBatchUpload;
  treeBatchUploadLoading = false;
  processingDocument = false;
  processingDocumentPercent = 0;
  uploadStatus = 'Uploading';

  get treeBatchUploadDialog() {
    return FloweringStore.TreeBatchUploadDialog;
  }
  set treeBatchUploadDialog(value: boolean) {
    FloweringStore.setTreeBatchUploadDialog(value);
  }

  get farms() {
    return FarmStore.Farms.map(x => {
      return { value: x.id, label: x.name };
    });
  }

  get blocks() {
    return BlockStore.SimpleBlocks.map(x => {
      return { value: x.id, label: x.name };
    });
  }

  get selectedFarmBlock() {
    return CommonStore.SelectedFarmBlock;
  }

  @Watch('selectedFarmBlock', { deep: true })
  onSelectedFarmBlockChange() {
    this.data.farm = this.selectedFarmBlock.farmId;
  }

  @Watch('treeBatchUploadDialog')
  onImportBlockDialogVisible() {
    this.onSelectedFarmBlockChange();
  }

  async updateProcessingStatus(id: number) {
    this.processingDocument = true;
    const processingStatus: UploadProgress = await FloweringStore.updateTreeProcessingStatus(
      id
    );
    if (
      processingStatus.taskStatus &&
      processingStatus.taskStatus != 'STARTED'
    ) {
      this.uploadStatus = processingStatus.taskStatus;
    }
    if (processingStatus.taskDetail.progress) {
      this.processingDocumentPercent = processingStatus.taskDetail.progress;
    }
    this.uploadStatus = processingStatus.taskStatus;
    if (processingStatus.taskStatus == 'COMPLETED') {
      const taskDetail = processingStatus.taskDetail;
      let message = `Trees added successfully`;
      if (taskDetail.totalData == taskDetail.createdData) {
        // message = `Trees added successfully. All trees were added.`;
      } else {
        message = `Trees added successfully. Out of "${taskDetail.totalData}", "${taskDetail.createdData}" trees were added.`;
      }
      this.$q.notify({
        type: 'positive',
        message: message,
        timeout: 5000
      });
      this.processingDocument = false;
      this.onReset();
    } else if (processingStatus.taskStatus == 'ERROR') {
      let message = `Could not process trees.`;
      if (processingStatus.taskDetail.message) {
        message += processingStatus.taskDetail.message;
      }
      this.$q.notify({
        type: 'negative',
        message: message,
        timeout: 5000
      });
      this.processingDocument = false;
    } else {
      setTimeout(this.updateProcessingStatus, 5 * 1000, id);
    }
  }

  async onSubmit() {
    this.treeBatchUploadLoading = true;
    // eslint-disable-next-line
    const formData = new FormData();
    for (const key in this.data) {
      // eslint-disable-next-line
      formData.append(key, (this.data as any)[key]);
    }
    FloweringStore.batchUploadTree({ data: formData })
      .then(res => {
        const batchId = res.id;
        this.updateProcessingStatus(batchId);
        // const message = 'File uploaded successfully.';
        const message = 'File uploaded successfully. File is being processed.';
        this.$q.notify({
          type: 'positive',
          message: message,
          timeout: 5000
        });
      })
      .finally(() => {
        this.treeBatchUploadLoading = false;
      });
  }
  onReset() {
    this.data = {} as FloweringBatchUpload;
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
      this.treeBatchUploadDialog = false;
    });
  }

  async created() {
    BlockStore.getSimpleBlocks();
    await FarmStore.getAllMyFarms();
    this.onSelectedFarmBlockChange();
  }
}
